import React from 'react';
import useTheme from '@material-ui/core/styles/useTheme';
import { Box, useMediaQuery } from '@material-ui/core';
import FsBankLogoLoader from 'ui-elements/image-loaders/FsBankLogoLoader';
import {
  ContentBox,
  ThickVerticalDivider,
  Name,
  ContainerBox,
  DetailsBox,
  DetailsInfo,
  DetailsInfoLabel,
  NameBox,
  SingleValueBox,
  Status,
  StatusLabel,
  Value,
  ValueCaption,
  ValuesBox,
  HeaderBox,
} from './SingleAccountItem.style-elements';
import {
  getContainerStyle,
  getFontColorStyle,
  getVerticalDividerStyle,
} from './SingleAccountItem.style';
import { getDetails, getValues } from './SingleAccountItem.utils';

export interface SingleAccountItemDataProps {
  id: string;
  number: string;
  name: string;
  type: string;
  subtype: string;
  income: string;
  expenditure: string;
  balance: string;
  maturity: string;
  opening: string;
  bankName: string;
  bankId: number;
}

const SingleAccountItem: React.FC<SingleAccountItemDataProps> = ({
  number,
  name,
  type,
  subtype,
  income,
  expenditure,
  balance,
  maturity,
  opening,
  bankName,
}) => {
  const theme = useTheme();
  const isSelected = false;
  const isUpSm = useMediaQuery(theme.breakpoints.up('sm'));
  const containerStyle = getContainerStyle(isSelected, theme);
  const verticalDividerStyle = getVerticalDividerStyle(isSelected, theme);
  const fontColor = getFontColorStyle(isSelected, theme);
  const details = getDetails({ id: number, maturity, opening });
  const values = getValues({ balance, expenditure, income });

  return (
    <ContainerBox style={containerStyle}>
      {isUpSm && <ThickVerticalDivider style={verticalDividerStyle} />}
      <ContentBox>
        <HeaderBox>
          <FsBankLogoLoader bankName={bankName} />
          <NameBox>
            <Name style={fontColor}>{name}</Name>
            <Status style={fontColor}>
              {type}
              <StatusLabel style={fontColor}>({subtype})</StatusLabel>
            </Status>
            <DetailsBox>
              {details.map(({ label, value }) => (
                <DetailsInfo key={label} style={fontColor}>
                  <DetailsInfoLabel style={fontColor}>
                    {label}:
                  </DetailsInfoLabel>
                  {value}
                </DetailsInfo>
              ))}
            </DetailsBox>
          </NameBox>
        </HeaderBox>
        <ValuesBox>
          {values.map(({ caption, value }) => (
            <SingleValueBox key={caption}>
              <Box>
                <ValueCaption style={fontColor}>{caption}:</ValueCaption>
                <Value style={fontColor}>{value}</Value>
              </Box>
            </SingleValueBox>
          ))}
        </ValuesBox>
      </ContentBox>
    </ContainerBox>
  );
};

export default SingleAccountItem;
